import EmpytNavbar from "../Navbars/EmpytNavbar";

const StatusDot = ({ active }) => (
  <span
    className={`status-dot${active ? ' active' : ''}`}
    style={{ background: active ? '#2dce89' : '#f5365c' }}
  />
);

const StatBox = ({ title, value, color, subtitle }) => (
  <div className="bot-stat">
    <div className="bot-stat-title">{title}</div>
    <div className="bot-stat-value" style={{ color: color || 'white' }}>{value}</div>
    {subtitle && <div className="bot-stat-subtitle">{subtitle}</div>}
  </div>
);

// Estado del bot seleccionado: solo se muestra en las vistas del bot
export const BotStats = ({ statusBot, lastUpdate }) => {
  const running = statusBot?.running;
  const isBuy = statusBot?.isBuy;
  const hasTransaction = statusBot?.transaction;

  return (
    <div className="bot-stats">
      <StatBox
        title="Estado"
        value={
          <span>
            <StatusDot active={running} />
            {running ? 'Corriendo' : 'Detenido'}
          </span>
        }
        color={running ? '#2dce89' : '#f5365c'}
      />

      <StatBox
        title="Próxima acción"
        value={isBuy ? 'Esp. Vender' : 'Esp. Comprar'}
        color={isBuy ? '#fb6340' : '#2dce89'}
        subtitle={isBuy ? 'Posición abierta' : 'Buscando entrada'}
      />

      <StatBox
        title="Última op."
        value={hasTransaction ? 'Realizada ✓' : 'Pendiente…'}
        color={hasTransaction ? '#2dce89' : 'rgba(255,255,255,0.6)'}
      />

      {/* Hora del último fetch, no la del render */}
      <StatBox
        title="Actualizado"
        value={lastUpdate ? lastUpdate.toLocaleTimeString('es', { hour: '2-digit', minute: '2-digit', second: '2-digit' }) : '—'}
        color="white"
        subtitle={lastUpdate ? lastUpdate.toLocaleDateString('es', { day: '2-digit', month: 'short', year: 'numeric' }) : 'sin datos'}
      />
    </div>
  );
};

const Header = ({ refresh, setScrem, screm, logout, badges }) => (
  <EmpytNavbar setScrem={setScrem} refresh={refresh} screm={screm} logout={logout} badges={badges} />
);

export default Header;
